import styled, { createGlobalStyle } from "styled-components";
import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import type { ComponentProps } from "react";

export const SegmentsHomepageWrapper = styled.div`
    height: 100%;
`;

const SegmentsQueryBarContainer: any = styled.div`
    height: 64px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    font-size: 24px;
    line-height: 32px;
    font-weight: 500;
    color: ${colorsPalettes.carbon["500"]};
`;
SegmentsQueryBarContainer.displayName = "SegmentsQueryBarContainer";

export const SegmentsUpsellButton = styled(IconButton).attrs<Partial<ComponentProps<typeof IconButton>>>((props) => ({
    iconName: "locked",
    type: "upsell",
    iconSize: "xs",
    placement: "left",
}))<Omit<ComponentProps<typeof IconButton>, "iconName" | "type" | "iconSize" | "placement">>`
    svg path {
        fill-opacity: 1;
    }
`;

export const SegmentsTableStyles = createGlobalStyle`
    .segmentRowDisabled:after {
        display: block;
        content: "";
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: #fff;
        opacity: 0.75;
    }
`;

export const SegmentsAnalysisPageContainer = styled.div`
    flex-grow: 1;
    overflow-x: hidden;
    width: 100%;
`;
